import type {TradeControlsNotice} from '@github-ui/code-view-types'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {Banner} from '@primer/react'
import {useState} from 'react'

import {restoreFocusAfterDismiss} from '../restore-focus-after-dismiss'
import styles from './TradeControlsBanner.module.css'

interface TradeControlsBannerProps {
  notice: TradeControlsNotice
  returnFocusIds?: string[]
}

/**
 * The dismissal key is shared with the archived and migrating banners on the Rails
 * repo pages, so dismissing here suppresses all of them on the next page load.
 */
export function TradeControlsBanner({notice, returnFocusIds}: TradeControlsBannerProps) {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  const postDismissal = async () => {
    try {
      await verifiedFetch(notice.dismissPath, {method: 'POST'})
    } catch {
      return
    }
  }

  const dismissTradeControls = () => {
    restoreFocusAfterDismiss(returnFocusIds)
    setDismissed(true)
    void postDismissal()
  }

  return (
    <Banner variant="warning" title="Trade controls notice" hideTitle flush onDismiss={dismissTradeControls}>
      <Banner.Description className={styles.BannerDescription}>
        <VerifiedHTMLDiv html={notice.messageHtml} />
        <VerifiedHTMLDiv html={notice.ctaHtml} />
      </Banner.Description>
    </Banner>
  )
}
